import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/services.php';

export function getServices(filters = {}) {
    // Remove filtros vazios antes de enviar
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;
    
    const response = api.get(url);

    return response;
};

export function getServiceDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createService(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Categoria cadastrada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateService(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Categoria editada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteService(id, user_id) {

    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success("Serviço deletado com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar esse serviço!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};